const utils = require('frontend-controller/lib/utils')
const store = require('frontend-controller/lib/store')

module.exports = {
    config: {
        staticLookupName: 'projectViewer',
        heartbeatRefreshOn: {
            'reconnect': true,
            'resourceChanged.all': true,
            'resourceChanged.bo_projects': true,
            // 'resourceChanged.bo_customers': true,
            'resourceChanged.bo_employees': true,
            'resourceChanged.bo_projectTerms': true,
            'resourceChanged.bo_projectTermJobs': true,
            'resourceChanged.bo_projectTermJobStatus': true,
            // 'resourceChanged.bo_customerContacts': true
        }
    },

    model: {
        open: false,
        lastActiveProjectTermID: null, // used to save the active projecTermID during refreshes.
        userDecisionPromise: null, // stores a workflow promise until the user triggers the onDecision hook submit.
    },

    events: {
        userActions: {
            type: 'click',
            selector: 'button',
            action(event){
                const $target = $(event.target).closest('button')
                if($target.length > 0){
                    const {
                        fieldType,
                        buttonContext,
                        buttonMode,
                    } = $target[0].dataset || {}
                    const self = event.data.component

                    const projectID = $target.closest('[data-project-id]').data('projectId')
                    const projectTermID = $target.closest('[data-project-term-id]').data('projectTermId')
                    const projectTermJobIDs = String($target.closest('[data-project-term-id]').data('projectTermJobIds') || '').split(',')

                    if(typeof (self || {})[fieldType || 'NOFUNCTIONATALL'] === 'function'){
                        self[fieldType].apply(self, [buttonContext, buttonMode, projectID, projectTermID, projectTermJobIDs, $target.closest('.templates_crew_projects_viewerField')])
                    }
                }
            }
        }
    },

    methods: {
        getResourceFilters: function(storage, resourceFilters, actionKey, fieldCode){
            if(actionKey === 'refreshResources'){
                resourceFilters = resourceFilters || {}

                if(utils.collectionSize(this.model.resourceFilters) > 0){
                    utils.refReplace(resourceFilters, this.model.resourceFilters)
                }

                this.model.resourceFilters = resourceFilters
            }

            return resourceFilters
        },

        loadResourcesGranted(storage, resourceFilters, actionKey, fieldCode, attachTriggerOptions){
            if(actionKey === 'refreshResources'){
                if((resourceFilters || {}).projectID) return true;
                return false
            }

            return true
        },

        sanitizeResources(storage){
            const userTableAssociates = ((storage.user || {}).data || {}).userTableAssociates || {}
            const employee      = userTableAssociates.employee || {}
            const contractor    = userTableAssociates.contractor || {}
            const employeeID    = employee.employeeID
            const contractorID  = contractor.contractorID
            const attributes    = (this.resourceData.data || {}).attributes || {}

            this.model.projectID = attributes.projectID
            this.model.availableProjectTermIDs = attributes.availableTermIDs || {}
            this.model.projectTermIDs = {}

            for(const t in attributes.terms || []){
                const project = this.resourceData.data.attributes || {}
                const customerContact = project.customerContact = project.customerContact || {}
                const term      = project.terms[t] || {}
                term.jobs       = term.jobs || {}
                this.model.projectTermIDs[term.projectTermID] = true

                const myJobs= term.myJobs = {}
                term.printDay = false
                let baseDay = ''
                if(term.startTS){
                    baseDay = utils.moment(term.startTS).format('YYYY-MM-DD')
                }
                for(const [j, job] of Object.entries(term.jobs || {})) {
                    if(
                        job.employeeID && job.employeeID == employeeID
                        ||
                        job.contractorID && job.contractorID == contractorID
                    ){
                        myJobs[j] = job

                        const showTime  = job.showTime = {
                            startTS:    null,
                            endTS:      null,
                            duration:   0,
                        }

                        if(job.timeRegistrationStartTS){
                            showTime.startTS     = job.timeRegistrationStartTS
                            showTime.endTS       = job.timeRegistrationEndTS
                            showTime.duration    = job.timeRegistrationDuration || 0
                        } else if(job.startTS){
                            showTime.startTS     = job.startTS
                            showTime.endTS       = job.endTS
                            showTime.duration    = job.duration || 0
                        } else if(employee.isManager){
                            showTime.startTS     = term.startTS
                            showTime.endTS       = term.endTS
                            showTime.duration    = term.duration || 0
                        }

                        if(showTime.startTS){
                            const timeParts = []
                            timeParts.push(utils.moment(showTime.startTS).format('HH:mm'))
                            if(showTime.endTS){
                                timeParts.push(utils.moment(showTime.endTS).format('HH:mm'))
                            }
                            showTime.time = timeParts.join(' - ')

                            if(!term.printDay && baseDay && utils.moment(showTime.startTS).format('YYYY-MM-DD') !== baseDay){
                                term.printDay = true
                            }
                        }
                    }
                }

                if(term.printDay){
                    for(const myJob of Object.values(myJobs)){
                        const showTime = myJob.showTime
                        if(showTime.time && showTime.startTS){
                            showTime.time = `${utils.moment(showTime.startTS).format('DD.MM.')} ${showTime.time}`
                        }
                    }
                }

                const contactPerson  = term.contactPerson = {
                    name:   null,
                    tel:    null,
                    mobile: null,
                }
                if(term.contactName || term.contactMobile){
                    contactPerson.name      = term.contactName || null
                    contactPerson.mobile    = term.contactMobile || null
                } else if(customerContact.firstname || customerContact.tel || customerContact.mobile){
                    contactPerson.name      = customerContact.firstname || null
                    contactPerson.tel       = customerContact.tel || null
                    contactPerson.mobile    = customerContact.mobile || null
                }
            }
        },

        show(projectID, projectTermID, projectTermJobID, options = {}){
            if(projectID){
                if(!this.model.open){
                    this.model.open = true
                    this.closest('base_tabStrip_tabContent', tabContent => {
                        const tab = tabContent.getTabComponent()
                        if(tab){
                            tab.$.removeClass('hidden')
                        }
                    })
                }

                this.model.resourceFilters = this.model.resourceFilters || {}
                this.model.resourceFilters.projectID = projectID
                this.model.resourceFilters.projectTermID = projectTermID || null
                this.model.resourceFilters.projectTermJobID = projectTermJobID || null
                this.model.resourceFilters.options = options || {}

                if(this.model.projectTermsTabStrip){
                    this.model.projectTermsTabStrip.clearTabs()
                }

                return this.refresh()
            }

            return utils.promise.resolve()
        },

        async showEdit(buttonContext, buttonMode, projectID, projectTermID, projectTermJobID, $viewerField, origin = 'viewer', returnOnUserDecisionPromise = false, additionalOptions = {}){
            const baseContext = String(buttonContext).split('_')[0] || ''
            const baseActionKey = `showEdit_${baseContext}`
            const actionKey = `${baseActionKey}_${buttonMode || 'UNKNOWN_BUTTON_MODE'}_inEffect`
            const { replaceShippingOrderID } = (additionalOptions || {})
            let result

            if(baseContext === 'timeRecordings'){
                buttonMode = buttonMode || 'timeRegistration'

                if(buttonMode === 'timeRegistration' || buttonMode === 'shippingOrder'){

                    result = this.performAndStoreAction(
                        actionKey,
                        this.prepareAction(
                            baseActionKey,
                            undefined,
                            {
                                timeRecordingsTable: {
                                    resourceFilters: {
                                        projectID,
                                        projectTermID,
                                        type: buttonMode,
                                        userIntention: origin === 'shippingOrderTable' ? 'createShippingOrder' : '',
                                        replaceShippingOrderID,
                                    },
                                    buttonParams: {
                                        baseContext,
                                        buttonContext,
                                        buttonMode,
                                        projectID,
                                        projectTermID,
                                        projectTermJobID,
                                        origin,
                                        returnOnUserDecisionPromise,
                                        additionalOptions,
                                    }
                                }
                            },
                            {
                                source: {
                                    load: {
                                        componentData: {
                                            model: {
                                                titleKey: `modal.${baseActionKey}.titles.${buttonMode}`,
                                                buttons: {
                                                    submit: {
                                                        mode: buttonMode,
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        ),
                        true
                    )
                }
            } else if(baseContext === 'shippingOrders'){
                let projectTerm = {}
                for(const term of Object.values(((this.resourceData.data || {}).attributes || {}).terms || [])){
                    if(term.projectTermID == projectTermID){
                        projectTerm = term
                        break
                    }
                }


                result = this.performAndStoreAction(
                    actionKey,
                    this.prepareAction(
                        baseActionKey,
                        undefined,
                        {
                            shippingOrdersTable: {
                                resourceFilters: {
                                    projectID,
                                    projectTermID,
                                },
                                projectTerm,
                            }
                        },
                        {
                            source: {
                                load: {
                                    componentData: {
                                        model: {
                                            subTitleKey: `modal.${baseActionKey}.subTitles.${buttonMode || 'all'}`
                                        }
                                    }
                                }
                            }
                        }
                    ),
                    true
                )
            }

            if(returnOnUserDecisionPromise){
                if(this.model.userDecisionPromise){
                    console.error('userDecisionPromise not available')
                } else {
                    this.model.userDecisionPromise = utils.promise.newCustom(this)
                    return this.model.userDecisionPromise
                }
            }

            return result || utils.promise.resolve()
        },

        edit(buttonContext, buttonMode, projectID, projectTermID, projectTermJobIDs, $viewerField){
            const baseActionKey = `edit_${buttonContext}`

            if(buttonContext === 'projectTermJobStatus'){
                const status        = buttonMode // read, agreed, revoked, applied, waitlisted

                if(projectTermJobIDs.length && (status === 'read' || status === 'agreed' || status === 'revoked' || status === 'applied' || status === 'waitlisted')){
                    return this.performAction(
                        this.prepareAction(
                            baseActionKey,
                            undefined,
                            undefined,
                            {
                                source: {
                                    submit: {
                                        data: {
                                            resourceParams: {
                                                projectTermJobIDs,
                                                status,
                                            }
                                        }
                                    }
                                }
                            }
                        ),
                    )
                }
            }

            return utils.promise.resolve()
        },

        showFullText(buttonContext, buttonMode, projectID, projectTermID, projectTermJobID, $viewerField){
            if(($viewerField || []).length > 0){
                const $text = $viewerField.find('.content > .text')
                if($text.length > 0){
                    const message = String($text[0].innerHTML || '???')
                        .replace(/^\n+/g, '')
                        .replace(/\n+$/g, '')
                        .replace(/\n/g, '<br>')

                    return this.performMessage({
                        messageDisplay: {
                            alreadyTranslated: true,
                            message
                        }
                    }, {
                        source: {
                            load: {
                                componentData: {
                                    model: {
                                        // set via caller component
                                        titleKey: 'projects.crewViewer.modals.showFullText.title'
                                    },
                                    config: {
                                        additionalClasses: 'flexHeight',
                                        decisionMaker: true, // viewer has to trigger heartbeat on decision if necessary
                                    }
                                }
                            }
                        }
                    })
                }
            }
        },

        refreshData(){
            if(this.model.projectTermsTabStrip){
                const termViewer = this.model.projectTermsTabStrip.getActiveTabComponent('tabContent')
                if(termViewer){
                    this.model.lastActiveProjectTermID = termViewer.$.data('projectTermId') || null
                }
            }

            this.refresh()
        },

        async initProjectTerms(){
            if(!this.model.projectTermsTabStrip){
                return
            }
            this.model.projectTermsTabStrip.clearTabs()

            const employee = ((((window.storage || {}).user || {}).data || {}).userTableAssociates || {}).employee || {}
            const project = (this.resourceData.data || {}).attributes || {}
            const terms = project.terms || []
            for(const term of Object.values(terms)){
                let grantAutoFocus = false
                if(this.model.lastActiveProjectTermID){
                    grantAutoFocus = term.projectTermID == this.model.lastActiveProjectTermID
                } else {
                    grantAutoFocus = term.projectTermID == this.model.resourceFilters.projectTermID
                    // TODO: this.model.resourceFilters.projectTermID may be set invalid via url-query-param => showMessage??
                }

                const showAllProjectTerms = (((this.model.resourceFilters || {}).options || {}).schedulerOptions || {}).showAllProjectTerms && this.hasRoleInScope('office')
                const myJobs = Object.values(term.myJobs || {}).sort((a, b) => a.timeIndex - b.timeIndex)
                let isManager = employee.isManager
                let startTS
                for(const myJob of myJobs){
                    const job = myJob.job || {}
                    isManager = isManager || job.isManager || myJob.isManager
                    startTS = startTS || myJob.startTS
                }
                startTS = startTS || term.startTS

                let bottom = ''
                if((isManager || showAllProjectTerms) && !project.isInternal){
                    const bottomParts = []
                    let classes = []

                    if(term.isLastProjectsTermInShippingOrderGroup || term.hasShippingOrder){
                        classes = ['fi fi-shipping-order']
                        if(term.hasShippingOrder){
                            if(term.isLastProjectsTermInShippingOrderGroup){
                                classes.push('green')
                            } else {
                                classes.push('gray')
                            }
                        } else if(term.isLastProjectsTermInShippingOrderGroup && term.isInPast){
                            classes.push('red')
                        } else {
                            classes.push('lightgray')
                        }

                        bottomParts.push(`<i class="${classes.join(' ')}"></i>`)
                    }

                    classes = ['fi fi-time-registration']
                    if(term.shippingOrderTimesComplete && term.timeRegistrationTimesComplete){
                        classes.push('green')
                    } else {
                        classes.push('red')
                    }
                    bottomParts.push(`<i class="${classes.join(' ')}"></i>`)
                    bottom = bottomParts.join('')
                }

                await this.performAndStoreAction(
                    undefined,
                    this.prepareAction(
                        'showTerm',
                        undefined,
                        {
                            tabOptions: {
                                title: utils.moment(startTS).format('DD.MM.YYYY'),
                                grantAutoFocus,
                                bottom,
                            },
                            tabContents: {
                                data: {
                                    attributes: term
                                },
                                meta: {
                                    showAllProjectTerms,
                                    project: {
                                        isInternal: project.isInternal,
                                    },
                                }
                            }
                        }
                    ),
                )
            }

            this.model.lastActiveProjectTermID = null
        },

        // patch data according to the given parameters
        async edit_timeRecordings(buttonParams, projectTerms, projectTermJobs){
            // TODO: what if no projectID is given?
            const projectID = buttonParams.projectID
            const contextProjectTermID = buttonParams.projectTermID
            const replaceShippingOrderID = (buttonParams.additionalOptions || {}).replaceShippingOrderID

            // prepare projectTerm updates
            const projectTermData = []
            if(buttonParams.buttonMode === 'timeRegistration'){
                for(const projectTermID in projectTerms || {}){
                    const term = projectTerms[projectTermID]
                    if(projectTermID){
                        projectTermData.push({
                            primaryKey: 'projectTermID',
                            attributes: {
                                projectTermID,
                                catering: !!term.catering,
                            }
                        })
                    }
                }
            }

            // prepare projectTermJob updates
            const projectTermJobData = []
            for(const job of Object.values(projectTermJobs || {})){
                const attributes = job.attributes || {}
                const _primaryKey = attributes[job.primaryKey || '_NO_PK_FOUND']

                if(_primaryKey){
                    projectTermJobData.push({
                        primaryKey: job.primaryKey,
                        attributes: {
                            [job.primaryKey]:   _primaryKey,
                            jobID:              attributes.jobID || undefined,
                            startTS:            attributes.startTS,
                            endTS:              attributes.endTS,
                            duration:           attributes.duration,
                        }
                    })
                }
            }

            const result = {}
            if(projectTermData.length > 0 || projectTermJobData.length > 0){
                result.projectTerms = ((((await this.performAction(
                    this.prepareAction(`edit_timeRecordings_${buttonParams.buttonMode}`, undefined, undefined, {
                        source: {
                            submit: {
                                data: {
                                    resourceParams: {
                                        projectID,
                                        projectTermID:      contextProjectTermID,
                                        replaceShippingOrderID,
                                        projectTerms:       projectTermData,
                                        projectTermJobs:    projectTermJobData
                                    }
                                }
                            }
                        }
                    })
                ) || {}).response || {}).data || [])[0] || {}).projectTerms || {}
            }

            return utils.promise.resolve(result)
        },

        onHeartbeat(message, heartbeatPrewarmedResourceHashes){
            const grantRefreshIfModalIsActive = [
                'container_templates_crew_advertisements_detail',
                'container_templates_crew_absence_properties_propertiesForm',
                'container_base_error_messageDisplay',
            ]

            const refreshGranted    = $(`body > .base_modal_modal:not(.invisible)${grantRefreshIfModalIsActive.map(componentClass => `:not(.${componentClass})`).join('')}`).length < 1 // prevent heartbeat refresh during user-input-phase
            const refreshers        = this.config.heartbeatRefreshOn || {}
            const key               = message.heartbeatKey
            const myEmployeeID      = (((((storage || {}).user || {}).data || {}).userTableAssociates || {}).employee || {}).employeeID

            let projectTermIDFound = message.data.projectTermID && (this.model.projectTermIDs[message.data.projectTermID] || this.model.availableProjectTermIDs[message.data.projectTermID])
            if(!projectTermIDFound && utils.collectionSize(message.data.projectTermIDs) > 0){
                for(const projectTermID in message.data.projectTermIDs){
                    if(this.model.projectTermIDs[projectTermID]){
                        projectTermIDFound = true
                        break
                    }
                }
            }

            if(refreshers[key] && (
                (key === 'reconnect') ||
                (key === 'resourceChanged.bo_projects' && message.data.projectID == this.model.projectID) ||
                (key === 'resourceChanged.bo_projectTerms' && (
                    message.data.projectID == this.model.projectID ||
                    (message.data.projectIDs || {})[this.model.projectID]
                )) ||
                (key === 'resourceChanged.bo_projectTermJobs' && projectTermIDFound) ||
                (key === 'resourceChanged.bo_projectTermJobStatus' && myEmployeeID && myEmployeeID == message.data.employeeID) ||
                (key === 'resourceChanged.bo_employees' && myEmployeeID && myEmployeeID == (message.data.primaryKey || message.data.employeeID))
            )){
                if(refreshGranted){
                    this.delayedLastOf('refreshByHeartbeat', () => this.refreshData(), 50)
                } else {
                    this.model.triggerHeartbeat = {message, heartbeatPrewarmedResourceHashes}
                }
            }
        },
    },

    hooks: {
        attach($element, options){
            if(!this.model.projectTermsTabStrip){
                this.find('base_tabStrip_tabStrip', tabStrip => {
                    this.model.projectTermsTabStrip = tabStrip
                })
            }

            if(!options.refresh && !this.model.open){
                this.closest('base_tabStrip_tabContent', tabContent => {
                    const tab = tabContent.getTabComponent()
                    if(tab){
                        tab.$.addClass('hidden')
                    }
                })
            }

            this.initProjectTerms()
        },

        async onDecision($element, options){
            const statusController = getComponent('statusController')
            let hideModal = true

            if(options.decisionComponent.hasClass('base_modal_modal')) {
                const modalContentComponent = options.decisionComponent.actions.loadContent.source.load.component

                switch(options.decisionType){
                    case 'submit':
                        if(modalContentComponent.hasClass('templates_crew_timeRecordings_propertiesForm_propertiesForm')){
                            let timeTable
                            modalContentComponent.find('templates_crew_timeRecordings_table_table', timeTableComponent => (timeTable = timeTableComponent))

                            // update projectTerms and projectTermJobs
                            const buttonParams              = timeTable.model.buttonParams || {}
                            const updateProjectTermsData    = utils.simpleCopy(timeTable.model.projectTermFields || {})
                            const updateProjectTermJobsData = utils.simpleCopy(timeTable.resourceData.data)
                            const replaceShippingOrderID    = (buttonParams.additionalOptions || {}).replaceShippingOrderID
                            if(statusController) {
                                statusController.showStatus('status.progress.save')
                            }
                            const {projectTerms} = await this.edit_timeRecordings(buttonParams, updateProjectTermsData, updateProjectTermJobsData)
                            if(statusController){
                                statusController.removeStatus()
                                statusController.addPanel('status.done.save')
                            }
                            if(this.model.userDecisionPromise){
                                this.model.userDecisionPromise.resolve()
                                delete this.model.userDecisionPromise
                            }

                            // showEdit shipping orders if necessary
                            if(buttonParams.baseContext === 'timeRecordings' && buttonParams.buttonMode === 'timeRegistration'){
                                hideModal = false
                                await options.decisionComponent.hide()
                                await this.showEdit(
                                    buttonParams.buttonContext,
                                    'shippingOrder',
                                    buttonParams.projectID,
                                    buttonParams.projectTermID,
                                    buttonParams.projectTermJobID,
                                    buttonParams.returnOnUserDecisionPromise
                                )
                            } else if(buttonParams.baseContext === 'timeRecordings' && buttonParams.buttonMode === 'shippingOrder'){
                                hideModal = false
                                await options.decisionComponent.hide()
                                let createShippingOrder = true
                                const projectTerm = (projectTerms || {})[buttonParams.projectTermID || '-1']


                                if(projectTerm && !projectTerm.hasShippingOrder && projectTerm.isLastProjectsTermInShippingOrderGroup){
                                    if(projectTerm.groupShippingOrderTimesComplete){
                                        if(buttonParams.origin !== 'shippingOrderTable'){
                                            const decisionContext = await this.performDecision(
                                                'confirm',
                                                {
                                                    component:  this,
                                                    title:      storage.__('projects.crewViewer.createShippingOrderAfterTimeRecordings.title'),
                                                    message:    storage.__('projects.crewViewer.createShippingOrderAfterTimeRecordings.message'),
                                                }
                                            ) || {}
                                            const decision = decisionContext.decision || {}
                                            if(decision.type !== 'yes'){
                                                createShippingOrder = false
                                            }
                                        }
                                    } else {
                                        createShippingOrder = false
                                        await this.performAction(
                                            this.prepareAction('message', undefined, {
                                                messageDisplay: {
                                                    message: 'projects.crewViewer.createShippingOrderAfterTimeRecordingsImpossibleDueToMissingShippingOrderTimes.message'
                                                }
                                            }, {
                                                statusControllerLoadingMessage: '',
                                                statusControllerSavingMessage:  ''
                                            })
                                        )
                                    }
                                } else if(!replaceShippingOrderID) {
                                    createShippingOrder = false
                                }

                                if(createShippingOrder){
                                    const actionContext = await this.performAction(
                                        this.prepareAction('edit_timeRecordings_createShippingOrder', undefined, undefined, {
                                            source: {
                                                submit: {
                                                    data: {
                                                        resourceParams: {
                                                            projectID:      buttonParams.projectID,
                                                            projectTermID:  buttonParams.projectTermID,
                                                            replaceShippingOrderID
                                                        }
                                                    }
                                                }
                                            }
                                        })
                                    )

                                    // open shippingOrder if possible
                                    const document = ((((actionContext || {}).response || {}).data || {}).attributes || {}).document || {}
                                    if(document.url){
                                        // @see MARK: WINDOW_OPEN_VS_A_HREF
                                        // window.open(document.url)
                                        $(`<a href="${document.url}" target="_blank">Test</a>`)[0].click()
                                    }
                                }
                            }

                        }

                        // hide modal
                        if(hideModal){
                            await options.decisionComponent.hide()
                        }
                        break;

                    case 'cancel':
                    default:
                        if(modalContentComponent.hasClass('templates_crew_timeRecordings_propertiesForm_propertiesForm')){
                            if(statusController) statusController.removeStatus();
                        }

                        // hide modal
                        if(hideModal){
                            await options.decisionComponent.hide(true)
                        }
                        break;
                }

                if(this.model.userDecisionPromise){
                    this.model.userDecisionPromise.resolve()
                    delete this.model.userDecisionPromise
                }
            }


            // re-perform heartbeat if necessary
            const triggerHeartbeat = this.model.triggerHeartbeat
            if(triggerHeartbeat){
                delete this.model.triggerHeartbeat
                this.onHeartbeat(triggerHeartbeat.message, triggerHeartbeat.heartbeatPrewarmedResourceHashes)
            }
        },

    },

    handlers: [
        {
            name: 'heartbeat.resourceChanged',
            handle: function(callerComponent, message, heartbeatPrewarmedResourceHashes){
                this.onHeartbeat(message, heartbeatPrewarmedResourceHashes)
            }
        },
        {
            name: 'heartbeat.reconnect',
            handle: function(callerComponent, message, heartbeatPrewarmedResourceHashes){
                this.onHeartbeat(message, heartbeatPrewarmedResourceHashes)
            }
        },
        {
            name: 'schedulerOptionsChanged',
            handle: function(callerComponent, schedulerOptions){
                schedulerOptions = schedulerOptions || {}
                const lastSchedulerOptions = ((this.model.resourceFilters || {}).options || {}).schedulerOptions

                if(
                    (this.model.resourceFilters || {}).projectID
                    &&
                    (
                        (!lastSchedulerOptions && schedulerOptions.showAllProjectTerms)
                        ||
                        (lastSchedulerOptions && lastSchedulerOptions.showAllProjectTerms !== schedulerOptions.showAllProjectTerms)
                    )
                    &&
                    this.hasRoleInScope('office')
                ){
                    this.model.resourceFilters.options.schedulerOptions = schedulerOptions
                    this.refreshData()
                }
            }
        },
    ],
}